var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPhone = function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 2a2.5 2.5 0 0 0-2.5 2.5v11A2.5 2.5 0 0 0 7 18h6a2.5 2.5 0 0 0 2.5-2.5v-11A2.5 2.5 0 0 0 13 2H7ZM5.5 4.5A1.5 1.5 0 0 1 7 3h6a1.5 1.5 0 0 1 1.5 1.5v11A1.5 1.5 0 0 1 13 17H7a1.5 1.5 0 0 1-1.5-1.5v-11Zm5.333 9.667a.833.833 0 1 1-1.666 0 .833.833 0 0 1 1.666 0Z",
    fill: "#818C96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 2a2.5 2.5 0 0 0-2.5 2.5v11A2.5 2.5 0 0 0 7 18h6a2.5 2.5 0 0 0 2.5-2.5v-11A2.5 2.5 0 0 0 13 2H7ZM5.5 4.5A1.5 1.5 0 0 1 7 3h6a1.5 1.5 0 0 1 1.5 1.5v11A1.5 1.5 0 0 1 13 17H7a1.5 1.5 0 0 1-1.5-1.5v-11Zm5.333 9.667a.833.833 0 1 1-1.666 0 .833.833 0 0 1 1.666 0Z",
    fill: "#747F88"
  })));
};

export default SvgPhone;